<script>
    import { navigateTo } from 'svelte-router-spa'
    import { age } from '../../store.js'

    function nxt() {
        age.set($age)
        navigateTo('sex')
    }
</script>

<main>
    <div class="body">
        <h1>Enter your age</h1>
        <p>Ilagay ang iyong edad</p>
        <input type="number" bind:value={$age}>

        {#if $age}
        <a class="btn btn-primary" on:click={nxt}>Next</a>
        {/if}
    </div>
</main>